import type { AxiosClient } from './utils/client/axios';
import { ApiLayer } from './utils/api-layer';
import { axiosApp } from './utils/client/axios';

type HidePayload = {
  email: string;
  names?: string[];
};

class ContactLayer extends ApiLayer<AxiosClient> {
  hide(payload: HidePayload) {
    return this.methods.post('/contact/hidden', payload);
  }
}

export const ContactAPI = new ContactLayer(axiosApp);
